// Locale-aware path + share-link helpers for the Insights site. Indonesian
// pages live under a /id prefix; English at the root.

const prefix = (language) => (language === "id" ? "/id" : "");

export const insightsHome = (language) => `${prefix(language)}/insights`;

export const categoryPath = (language, slug) =>
  `${prefix(language)}/insights/c/${slug}`;

export const insightPath = (language, slug) =>
  `${prefix(language)}/insights/${slug}`;

export const shareLinks = (url, title) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    x: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    line: `https://social-plugins.line.me/lineit/share?url=${u}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${u}&description=${t}`,
    email: `mailto:?subject=${t}&body=${u}`,
  };
};
